import React, { useState, useEffect } from 'react';
import './App.css';

const Quiz = ({ onAnswer, team }) => {
  const apiHost = "10.249.97.146";
  const [question, setQuestion] = useState(null);
  const [timer, setTimer] = useState(30);
  const [showNextPlayButton, setShowNextPlayButton] = useState(false);
  const [isCorrect, setIsCorrect] = useState(null); // New state to track correctness

  useEffect(() => {
    const fetchQuestion = () => {
      const { grade, subject, topic } = team;
      const endpoint = `http://${apiHost}:5000/api/question/${grade}/${subject}/${topic}`;
      fetch(endpoint)
        .then(response => response.json())
        .then(data => setQuestion(data));
    };

    fetchQuestion();
  }, [team, apiHost]);

  useEffect(() => {
    if (timer === 0) {
      setShowNextPlayButton(true);
    }

    const interval = setInterval(() => {
      setTimer(prevTimer => (prevTimer > 0 ? prevTimer - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleOptionClick = (option) => {
    const isCorrect = option === question.answer;
    setIsCorrect(isCorrect); // Set the correctness state
    onAnswer(isCorrect);
    setShowNextPlayButton(true);
    setTimer(30);
  };

  const handleNextPlay = () => {
    setShowNextPlayButton(false);
    setIsCorrect(null); // Reset correctness state
    // Fetch the next question here if needed
  };

  if (!question) {
    return <div>Loading...</div>;
  }

  return (
    <div className="quiz">
      {!showNextPlayButton && (
        <>
          <h2>{question.question}</h2>
          <div className="timer">Time left: {timer} seconds</div>
          <div className="options">
            {question.options.map((option, index) => (
              <button key={index} onClick={() => handleOptionClick(option)} className="option-button">
                {option}
              </button>
            ))}
          </div>
        </>
      )}
      {showNextPlayButton && (
        <>
          <div className={`answer ${isCorrect ? 'correct' : 'wrong'}`}>
            {isCorrect ? 'Correct!' : 'Wrong!'}
          </div>
          <button onClick={handleNextPlay} className="next-play-button">Next Play</button>
        </>
      )}
    </div>
  );
};

export default Quiz;